import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMoney = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M6.61 2.35a2.49 2.49 0 0 0-2.72 3.783 8.378 8.378 0 0 1 4.487-1.302h.077A2.49 2.49 0 0 0 6.61 2.349Zm4.109 2.48A4.755 4.755 0 1 0 2.155 7.6a8.377 8.377 0 0 0 .26 11.492v1.965a2.943 2.943 0 0 0 5.84.527l.122.001h4.83M4.467 8.509a6.113 6.113 0 0 0-.164 9.256c.251.225.39.55.377.886v2.406a.68.68 0 0 0 1.358 0v-.704a1.132 1.132 0 0 1 1.319-1.117 6.16 6.16 0 0 0 1.02.085h4.83c.342 0 .684-.028 1.021-.085a1.132 1.132 0 0 1 1.32 1.117v.704a.679.679 0 1 0 1.358 0v-2.448c0-.322.137-.628.376-.843a6.133 6.133 0 0 0 1.69-2.52c.16-.453.588-.755 1.068-.755h1.62a.075.075 0 0 0 .076-.076V12a.075.075 0 0 0-.076-.075h-1.619c-.48 0-.907-.302-1.067-.754a6.136 6.136 0 0 0-2.71-3.259 1.132 1.132 0 0 1-.565-.98V4.455l-3.675 2.45a1.13 1.13 0 0 1-.628.19H9.438a1.126 1.126 0 0 1-.117 0h-.944a6.113 6.113 0 0 0-3.91 1.414ZM10.72 4.83h.335l5.148-3.433c.186-.124.405-.19.628-.19h.001c.626 0 1.133.507 1.133 1.132v3.97a8.4 8.4 0 0 1 2.835 3.35h.861A2.34 2.34 0 0 1 24 12v2.415a2.34 2.34 0 0 1-2.34 2.34h-.862a8.4 8.4 0 0 1-1.628 2.338v1.964a2.943 2.943 0 0 1-5.84.527l-.123.001m2.417-11.924c.625 0 1.132.507 1.132 1.132v.012a1.132 1.132 0 1 1-2.264 0v-.012c0-.625.507-1.132 1.132-1.132Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMoney);
export default ForwardRef;
